import BaseIcon from '@/src/assets/icons'
import { useLocationModules } from '@/src/hooks/location-module/location-module.hooks'
import { getAuthRouteToNavigate } from '@/src/routes/routes.components'
import { appColors } from '@/src/theme'
import { Text } from '@chakra-ui/react'
import { FlexRow } from '@components'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

interface NavbarEcoplanetLogoProps {
  uncollapse: () => void
  isCollapsed: boolean
}

export const NavbarEcoplanetLogo: FC<NavbarEcoplanetLogoProps> = ({ uncollapse, isCollapsed }) => {
  const navigate = useNavigate()
  const { data: enabledModulesData } = useLocationModules()
  const routeToNavigate = getAuthRouteToNavigate(enabledModulesData?.enabledModules ?? [])
  const { t } = useTranslation()

  return (
    <FlexRow
      mt='28px'
      ml={isCollapsed ? 5 : 6}
      borderRadius={'full'}
      cursor={'pointer'}
      onClick={() => {
        if (!isCollapsed) {
          navigate(routeToNavigate)
        } else {
          uncollapse()
        }
      }}
    >
      {!isCollapsed && (
        <Text mr='10px' fontSize={'14px'} color={appColors.secondaryForeground}>
          {t('poweredBy')}
        </Text>
      )}
      {isCollapsed ? (
        <BaseIcon width={'28px'} height={'24px'} name='ecoplanetLettermarkLogo' />
      ) : (
        <BaseIcon width={'118px'} height={'24px'} name='ecoplanetLogo' />
      )}
    </FlexRow>
  )
}
